import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-template-metrics',
  templateUrl: './edit-template-metrics.component.html',
  styleUrls: ['./edit-template-metrics.component.css']
})
export class EditTemplateMetricsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/template-metrics/edit-template-metrics/edit-template-metrics.component.ts